import { useConfirm } from 'components/Alert/useConfirm';
import { useMutation } from 'query';
import { undo } from 'scenes/FinancePage/SA/data/queryKeyFactory';
import { undoSA } from 'scenes/FinancePage/SA/sources';

export const useUndo = () => {
  const confirm = useConfirm();

  const approveMutation = useMutation(undo(), undoSA, {
    refresh: true,
    successMessage: () => `Spend Adjustment undone`,
  });

  const handleAction = ({ id }: any) => {
    confirm({
      title: `Undo Spend Adjustment ${id}?`,
      confirmActionLabel: 'Undo',
    }).then(() => approveMutation.mutateAsync({ id }));
  };

  return [handleAction, approveMutation];
};
